import React from "react";

import { PRACTICE_SLUG } from "models";

import { PracticeList } from "pages/admin/verifications/components/lists/PracticeList";
import { TillageAndSeedingTable } from "pages/admin/verifications/components/misc/TillageAndSeedingTable";
import { TillageAndSeedingTimeline } from "pages/admin/verifications/components/misc/TillageAndSeedingTimeline";

export const TillageAndSeedingList = ({ farmId }: { farmId: string }) => (
  <PracticeList
    farmId={farmId}
    practiceSlugs={[PRACTICE_SLUG.TILLAGES, PRACTICE_SLUG.SEEDINGS]}
    renderTimeline={(fieldId) => <TillageAndSeedingTimeline fieldId={fieldId} />}
    renderExpandedContent={(field) => <TillageAndSeedingTable field={field} farmId={farmId} />}
  />
);
